// /v3/analytics/network/:stationId/totalPlays?userId=203825

export type NetworkTotalPlaysParameters = {
  webStationId: string;
  userId: number;
};

export type NetworkTotalPlaysResponse = {
  stationId: number;
  kind: 'totalPlays';
  data: {
    rows: [number][];
  };
  columnHeader: {
    name: 'Plays';
    type: 'integer';
  };
};

export async function fetchNetworkTotalPlays({
  webStationId,
  userId,
}: NetworkTotalPlaysParameters): Promise<NetworkTotalPlaysResponse> {
  try {
    const response = await fetch(
      `/api/proxy/v3/analytics/network/webStationId:${webStationId}/totalPlays?userId=${userId}`,
      {
        method: 'GET',
        credentials: 'same-origin',
      }
    );
    if (response.ok) {
      return await response.json();
    }
    throw new Error(`Could not fetch this network's total plays`);
  } catch (err) {
    throw new Error(err.message);
  }
}
